
import axios from 'axios';
import { API_PUBLIC_KEY } from '../config/api';
import { isAuthenticationFailure } from '../utils/authentication';
import { getAppPath } from '../utils/appUrl';

export const DEV_API_URL = 'https://shop.rghtnow.com/v5_dev/public/api/';
export const LIVE_API_URL = 'https://shop.rghtnow.com/v5/public/api/';
export const API_ENV_STORAGE_KEY = 'rghtnow_api_environment';

const getStoredEnvironment = () => {
  if (typeof window === 'undefined') return 'dev';

  return localStorage.getItem(API_ENV_STORAGE_KEY) === 'live' ? 'live' : 'dev';
};

export const getApiUrl = (environment = getStoredEnvironment()) =>
  environment === 'live' ? LIVE_API_URL : DEV_API_URL;

export let baseURL = getApiUrl();

const axiosInstance = axios.create({
  baseURL: baseURL,
  headers: {
    'Content-Type': 'multipart/form-data',
    "Accept": "application/json",
    publicKey: API_PUBLIC_KEY,
  }
});

export const setApiEnvironment = (environment) => {
  const nextEnvironment = environment === 'live' ? 'live' : 'dev';
  baseURL = getApiUrl(nextEnvironment);
  axiosInstance.defaults.baseURL = baseURL;

  if (typeof window !== 'undefined') {
    localStorage.setItem(API_ENV_STORAGE_KEY, nextEnvironment);
  }

  return baseURL;
};

// ✅ Request Interceptor – token auto add
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('access_token');

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

const redirectToLogin = () => {
  if (typeof window === "undefined") return;

  const selectedEnvironment = localStorage.getItem(API_ENV_STORAGE_KEY);
  localStorage.clear();

  if (selectedEnvironment) {
    localStorage.setItem(API_ENV_STORAGE_KEY, selectedEnvironment);
  }
  localStorage.setItem('forceLogout', String(Date.now()));

  const logoutPath = getAppPath('/login');

  if (window.location.pathname !== logoutPath) {
    window.location.href = logoutPath;
  }
};

// Handle authentication failures returned as HTTP errors or successful API responses.
axiosInstance.interceptors.response.use(
  (response) => {
    if (isAuthenticationFailure(response)) {
      redirectToLogin();
      const error = new Error(response.data?.message || 'Unauthenticated');
      error.response = response;
      return Promise.reject(error);
    }

    return response;
  },
  (error) => {
    if (isAuthenticationFailure(null, error)) {
      redirectToLogin();
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
